module.exports = require("./sc.d.ts");